import style from './style.scss';
import notifyMounted from '../notify-mounted';

export const NoData = props => (
	<div class={style.no_data_wrapper}>
		<div class={style.no_data}>
			{ props.message || 'No Data Available' }
		</div>
	</div>
);

export const NoDataNotifyOnMount = notifyMounted(NoData);



// WEBPACK FOOTER //
// ./components/no-data/index.js